// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__cEOcq","actionsCol":"EnrolledClinics_actionsCol__Aepg2"};